import { Box, Typography } from '@mui/material';

import { useAppSelector } from 'store/hooks';
import MetaData from './MetaData';
import { muiStyles } from './muiStyles';
import { formatCreationDate } from './utils';

const Header = () => {
  const deal = useAppSelector((state) => state.deals.deal);
  const { name, createdAt } = deal;

  return (
    <Box sx={muiStyles.root}>
      <Box sx={muiStyles.title}>
        <Typography variant='responsiveHeading1'>{name}</Typography>
        <Typography variant='responsiveLabel1'>
          Created on {formatCreationDate(createdAt)}
        </Typography>
      </Box>

      <MetaData />
    </Box>
  );
};

export default Header;
